export default __webpack_public_path__ + "static/media/icon_amethyst.e1a4288e.png";